import { useEffect, useRef } from 'react';
import { MdMicOff } from 'react-icons/md';
import styles from './VideoTile.module.css';

export function VideoTile({ stream, isLocal, isMuted }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.srcObject = stream ?? null;
    }
  }, [stream]);

  return (
    <div className={styles.tile}>
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted={isLocal}
        className={`${styles.video} ${isLocal ? styles.mirrored : ''}`}
      />
      {isMuted && (
        <span className={styles.muteBadge} title="Muted">
          <MdMicOff size={12} />
        </span>
      )}
    </div>
  );
}
